<svg [attr.width]="width" [attr.height]="height" viewBox="0 0 10 5" class="carrot" [ngClass]="{'rotate-right': pointRight, 'rotate-left': pointLeft, 'rotate-up': pointUp}">
    <g [attr.stroke]="stroke" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
        <g transform="translate(-1392.000000, -396.000000)" class="inner-stroke" stroke-width="0.95">
            <g transform="translate(392.000000, 351.000000)">
                <g transform="translate(920.550000, 36.100000)">
                    <polyline points="80.75 9.5 84.55 13.3 88.35 9.5"></polyline>
                </g>
            </g>
        </g>
    </g>
</svg>